import styled, { css } from "styled-components";
import theme from "../../../Styles/theme";

interface ContainerProps {
  interactive?: boolean;
}

export const Container = styled.div<ContainerProps>`
  resize: none;
  font-size: 14px;
  color: black;
  border: solid 0.6px ${theme.colors.dark};
  padding: 0.2vh 1vw;
  width: 100%;

  
  

  background: transparent;
  overflow-x/*(eixo x)*/: auto; /*Agora quando necessário a rolagem da tabela é permitida(funcionamento para o mobile)*/

  
margin-bottom: 10px;
overflow-y: scroll;
height: 100%;
&::-webkit-scrollbar {
  width: 0.6vw;
  height: 0.6vw;
}
&::-webkit-scrollbar-thumb {
  background-color: ${theme.colors.dark}; /* color of the scroll thumb */
  border-radius: 0.25rem; /* roundness of the scroll thumb */
  height: 2px;
}
/* ${({ interactive }) =>
interactive &&
css`
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`} */
`;
